module.exports = __webpack_public_path__ + "static/img/pottery.e4e53e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/pottery.png
// module id = kkwk
// module chunks = 26